/* oxlint-disable perfectionist/sort-imports */
import "@/platform/utils/sentry";

import { initArgus } from "@solvari/argus/service";
import { initAbTesting } from "@solvari/ab-testing";
import { initCookiePopup, initHeyflowForm } from "@solvari/components";

import "@/platform/components/trustpilot-rating/trustpilotRating.css";
import "@/platform/layouts/default/default.css";
import "@/platform/components/header/header";
import "@/platform/components/footer/footer";

import { initPlatformVueIslands } from "@/platform/vueIslands";
import { initFontAwesome } from "@solvari/common-fe/integrations";
import {
  addMarketingParamsGtmEvent,
  initInteractionTracking,
} from "@solvari/argus";
import { getEnv, handleFloatingPromise } from "@solvari/utils";
import { localeToIso } from "@solvari/translations";
import { startUserDataGtmWatcher } from "@solvari/common-fe/composables";
/* oxlint-enable perfectionist/sort-imports */

async function main() {
  const argusSession = initArgus();
  void addMarketingParamsGtmEvent();
  initInteractionTracking();
  initCookiePopup();
  initFontAwesome();

  await initAbTesting(argusSession.clientId, {
    siteLocale: localeToIso(getEnv().config.localeCode),
    siteType: "platform",
  });
  initPlatformVueIslands();

  startUserDataGtmWatcher();

  handleFloatingPromise(initHeyflowForm());
}

handleFloatingPromise(main());
